import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#007AA5', // glaucous
    },
    secondary: {
      main: '#F2CB05', // harvest-gold
    },
    background: {
      default: '#202020', // background_dark
    },
    text: {
      primary: '#E6E6FA', // lavender-web
    },
  },
});

export default theme;
